import { History } from 'history';

type JsonObj = Record<string, any>;

export const navigateToPage = (history: History, url: string, props?: JsonObj) => {
  history.push(url, props);
};

export * from './actions.common';
